<div class="contact-shell">
  <header class="contact-header">
    <div>
      <h1>Company Contact Details</h1>
    </div>
    <div class="contact-header__actions">
      <button type="button" class="button button--secondary" (click)="goBack()">
        Back to Companies
      </button>
      <button type="button" class="button button--ghost" (click)="refresh()">
        Refresh
      </button>
      <button
        type="button"
        class="button button--accent"
        (click)="generateAllContacts()"
        [disabled]="contactActionPending()"
      >
        Generate All Contacts
      </button>
      <button
        type="button"
        class="button button--accent"
        (click)="exportContacts()"
        [disabled]="contactActionPending()"
      >
        Export Excel
      </button>
      <button type="button" class="button button--primary" (click)="goNext()">
        Next
      </button>
    </div>
  </header>

  <nav class="breadcrumb">
    <a routerLink="/">Home</a>
    <span class="breadcrumb__separator">›</span>
    <a [routerLink]="['/audiences', serviceId()]" *ngIf="serviceId() as sid; else contactAudienceFallback">
      Target Audience Profiles
    </a>
    <ng-template #contactAudienceFallback>
      <span>Target Audience Profiles</span>
    </ng-template>
    <span class="breadcrumb__separator">›</span>
    <a [routerLink]="['/target-areas', serviceId()]" *ngIf="serviceId() as sid2; else contactTargetFallback">
      Target Areas
    </a>
    <ng-template #contactTargetFallback>
      <span>Target Areas</span>
    </ng-template>
    <span class="breadcrumb__separator">›</span>
    <span>Company Contact Details</span>
  </nav>

  <section class="contact-metrics">
    <div class="metric-card">
      <span class="metric-card__label">Crawled</span>
      <span class="metric-card__value">{{ crawlCount() }}</span>
    </div>
    <div class="metric-card">
      <span class="metric-card__label">Uncrawled</span>
      <span class="metric-card__value">{{ uncrawlCount() }}</span>
    </div>
    <div class="metric-card">
      <span class="metric-card__label">Total Records</span>
      <span class="metric-card__value">{{ totalCompanies() }}</span>
    </div>
  </section>

  <section class="contact-status">
    <span class="status status--info" *ngIf="loading()">
      <span class="spinner__dot"></span>
      <span>Fetching contact details...</span>
    </span>
    <span class="status status--success" *ngIf="!loading() && statusMessage()">
      {{ statusMessage() }}
    </span>
    <span class="status status--error" *ngIf="errorMessage()">
      {{ errorMessage() }}
    </span>
  </section>

  <section class="contact-search">
    <label class="search-field">
      <span class="search-field__label">Search Companies</span>
      <div class="search-field__control">
        <input
          [formControl]="searchControl"
          type="search"
          placeholder="Filter by company name, email, phone, or URL"
        />
        <button
          type="button"
          class="button button--ghost"
          (click)="clearSearch()"
          *ngIf="hasFilter()"
        >
          Clear
        </button>
      </div>
    </label>
  </section>

  <section
    class="contact-table-wrapper"
    *ngIf="filteredContacts().length && !loading(); else emptyState"
  >
    <table class="contact-table">
      <thead>
        <tr>
          <th>Company</th>
          <th>Website</th>
          <th>Phone Numbers</th>
          <th class="contact-table__actions-heading">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let record of filteredContacts()">
          <td>
            <div class="contact-table__company">
              <span class="contact-table__name">
                {{ record.company_name || 'Company' }}
              </span>
              <span class="contact-table__meta" *ngIf="record.company_size">
                {{ record.company_size }}
              </span>
            </div>
          </td>
          <td>
            <a
              *ngIf="record.website; else noWebsite"
              [href]="record.website"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ record.website }}
            </a>
          </td>
          <td>
            <ng-container *ngIf="renderList(record.phones).length; else noPhones">
              {{ renderList(record.phones).join(', ') }}
            </ng-container>
          </td>
          <td class="contact-table__actions">
            <button
              type="button"
              class="button button--accent button--small"
              (click)="generateContactsForRecord(record)"
              [disabled]="contactActionPending() || isRecordActionPending(record)"
            >
              <ng-container *ngIf="!isRecordActionPending(record); else recordPending">
                Generate Contacts
              </ng-container>
            </button>
            <button
              type="button"
              class="button button--primary button--small"
              (click)="viewDetails(record)"
            >
              View Details
            </button>
            <a
              class="button button--secondary button--small"
              [routerLink]="['/companies', serviceId(), locationId()]"
            >
              View Company Info
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </section>

  <ng-template #emptyState>
    <p class="contact-empty">
      No company contact details available yet. Generate contact records from the company page to populate this view.
    </p>
  </ng-template>

  <ng-template #noWebsite>N/A</ng-template>
  <ng-template #noPhones>N/A</ng-template>
  <ng-template #recordPending>
    <span class="spinner">
      <span class="spinner__dot"></span>
      <span>Preparing...</span>
    </span>
  </ng-template>
</div>
